import { Modal } from 'antd';
import FeedBack from '@/pages/Web/PageComponents/FeedBack';
import MobileFeedBack from '@/pages/Mobile/PageComponents/FeedBack';
import { showPopup, hidePopup } from './modal';
export const handleFeedBack = (data, checkIsLogin) => {
    window.feedBackModal = Modal.info({
        title: '用户反馈',
        width: 560,
        maskClosable: false,
        closable: true,
        icon: null,
        keyboard: false,
        content: <FeedBack data={data} checkIsLogin={checkIsLogin}></FeedBack>,
        footer: null
    });
};
export const closeFeedModal = () => {
    window.feedBackModal.destroy();
};
export const closeMobileFeedModal = () => {
    hidePopup();
};
export const handleMobileFeedBack = (data, checkIsLogin) => {
    const content = <MobileFeedBack data={data} checkIsLogin={checkIsLogin}></MobileFeedBack>;
    showPopup(content);
};
